/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class TrackService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Track telemetry events
     * @param requestBody The events to track.
     * @param projectId
     * @param xProjectToken
     * @returns any Request accepted
     * @throws ApiError
     */
    public trackPost(
        requestBody: Array<{
            /**
             * The unique ID of the user who triggered the event.
             */
            distinctId?: string;
            /**
             * The ID of the group or organization the event is associated with.
             */
            groupId?: string;
            /**
             * The name of the event to track, representing a specific user action.
             */
            name: string;
            /**
             * Unix timestamp of the event in milliseconds, representing the exact time the event was triggered.
             */
            timestamp?: number;
            /**
             * A dictionary of properties associated with the event, with key-value pairs representing event-specific data.
             */
            properties: Record<string, any>;
            /**
             * An anonymous identifier for the user, used when distinctId is not available.
             */
            anonymousId?: string;
            /**
             * Unique ID for tracking the request associated with the event.
             */
            requestId?: string;
            /**
             * Trace ID for distributed tracing, used to correlate requests across services.
             */
            traceId?: string;
            /**
             * Span ID for tracing the specific request within the trace context.
             */
            spanId?: string;
            /**
             * Parent span ID in a distributed trace, useful for nested request tracking.
             */
            parentSpanId?: string;
            /**
             * Start time of the span in milliseconds, when the event is associated with a span.
             */
            startTimeMs?: number;
            /**
             * End time of the span in milliseconds, when the event is associated with a span.
             */
            endTimeMs?: number;
            /**
             * Name of the service where the event originated.
             */
            service?: string;
            /**
             * The path of the request associated with the event.
             */
            path?: string;
            /**
             * HTTP method used in the request.
             */
            method?: string;
            /**
             * Log level for the event, used for real-time error tracking.
             */
            logLevel?: string;
            /**
             * Duration of the request in milliseconds.
             */
            durationMs?: number;
            /**
             * HTTP status code returned by the request.
             */
            statusCode?: number;
            /**
             * Duration of the trace in milliseconds.
             */
            traceDurationMs?: number;
            /**
             * Error message, if any, associated with the event.
             */
            error?: string;
            /**
             * Additional message or information related to the event.
             */
            message?: string;
            /**
             * Name of the span, representing a specific operation in distributed tracing tracing.
             */
            spanName?: string;
            /**
             * Full URL of the request associated with the event.
             */
            url?: string;
            /**
             * Platform type where the event originated (e.g., web, iOS, Android).
             */
            platform?: string;
            /**
             * Model of the platform, typically device model or browser type.
             */
            platformModel?: string;
            /**
             * Version of the platform.
             */
            platformVersion?: string;
            /**
             * Country from which the event was triggered.
             */
            country?: string;
            /**
             * City from which the event was triggered.
             */
            city?: string;
            /**
             * Timezone of the location where the event occurred.
             */
            timezone?: string;
            /**
             * Region from which the event originated.
             */
            region?: string;
            /**
             * Type of device used to trigger the event.
             */
            deviceType?: string;
            /**
             * Unique ID for the device used.
             */
            deviceId?: string;
            /**
             * Browser used to trigger the event.
             */
            browser?: string;
            /**
             * Operating system of the device.
             */
            os?: string;
            /**
             * Version of the operating system.
             */
            osVersion?: string;
            /**
             * Version of the browser used.
             */
            browserVersion?: string;
        }>,
        projectId?: string | null,
        xProjectToken?: string | null,
    ): CancelablePromise<{
        message: {
            message: 'Request accepted';
        };
        success: boolean;
        error: any;
        result?: any;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/track/',
            headers: {
                'x-project-token': xProjectToken,
            },
            query: {
                'projectId': projectId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal error`,
            },
        });
    }
}
